import { Origin as ModernOrigin } from '@eversports/kernel'
import { assertNever } from './assertNever'

export enum Origin {
  MANAGER = 'ORIGIN_MANAGER',
  ANDROID = 'ORIGIN_ANDROID',
  IOS = 'ORIGIN_IOS',
  EVERSPORTS = 'ORIGIN_EVERSPORTS',
  WIDGET = 'ORIGIN_WIDGET',
  MARKETPLACE = 'ORIGIN_MARKETPLACE',
  ADMIN = 'ORIGIN_ADMIN',
  AGGREGATOR = 'ORIGIN_AGGREGATOR',
  PROVIDER_API = 'ORIGIN_PROVIDER_API',
}

export function mapOriginToString(input: Origin) {
  switch (input) {
    case Origin.ANDROID:
      return 'android'
    case Origin.IOS:
      return 'ios'
    case Origin.EVERSPORTS:
      return 'eversport'
    case Origin.WIDGET:
      return 'widget'
    case Origin.MARKETPLACE:
      return 'marketplace'
    case Origin.ADMIN:
      return 'admin'
    case Origin.MANAGER:
      return 'manager'
    case Origin.AGGREGATOR:
      return 'aggregator'
    case Origin.PROVIDER_API:
      return 'provider-api'
    default:
      return 'eversport'
  }
}

export function mapToModernOrigin(origin: Origin): ModernOrigin {
  switch (origin) {
    case Origin.ANDROID:
      return ModernOrigin.Android
    case Origin.IOS:
      return ModernOrigin.Ios
    case Origin.EVERSPORTS:
    case Origin.MARKETPLACE:
      return ModernOrigin.Marketplace
    case Origin.WIDGET:
      return ModernOrigin.Widget
    case Origin.ADMIN:
    case Origin.MANAGER:
      return ModernOrigin.Manager
    case Origin.AGGREGATOR:
      return ModernOrigin.Aggregator
    case Origin.PROVIDER_API:
      return ModernOrigin.ProviderApi
    default:
      return assertNever(origin)
  }
}

export function mapStringToOrigin(input?: string | null): Origin {
  if (!input) return Origin.EVERSPORTS

  input = input.toLowerCase()

  // Remove the prefix if there is one
  if (input.startsWith('origin_')) {
    input = input.slice('origin_'.length)
  }

  switch (input) {
    case 'android':
      return Origin.ANDROID
    case 'ios':
      return Origin.IOS
    case 'eversport':
      return Origin.EVERSPORTS
    case 'eversports':
      return Origin.EVERSPORTS
    case 'widget':
      return Origin.WIDGET
    case 'marketplace':
      return Origin.MARKETPLACE
    case 'admin':
      return Origin.ADMIN
    case 'manager':
      return Origin.MANAGER
    case 'aggregator':
      return Origin.AGGREGATOR
    case 'provider-api':
    case 'provider_api': // gql uses enum name `ORIGIN_PROVIDER_API` as a value, which must be SCREAMING_SNAKE_CASE. `origin_` is stripped above
      return Origin.PROVIDER_API
    default:
      return Origin.EVERSPORTS
  }
}
